export enum SfReportComponentType {
	AggregateColumn = 1,
	Column = 2,
	CrossFilterCriterion = 3,
	CrossFilter = 4,
	CustomDetailFormula = 5,
	CustomSummaryFormula = 6,
	Filter = 7,
	Grouping = 8
}
